var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        _vm._b(
          {
            staticClass: "d-flex rounded-xxs base-alert",
            class: {
              "bg-danger": ["error", "danger"].includes(_vm.status),
              "bg-success": _vm.status === "success",
              "bg-warning": _vm.status === "warning",
              "bg-info": _vm.status === "info",
              "bg-default": _vm.status === "default" || !_vm.status,
              "align-items-center": _vm.center
            },
            staticStyle: { position: "relative" }
          },
          "div",
          _vm.$attrs,
          false
        ),
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center container-icon",
              staticStyle: { width: "100%" }
            },
            [
              _c("span", {
                style: {
                  position: "absolute",
                  left: "0",
                  height: "40px",
                  width: "2px",
                  backgroundColor: _vm.colorIcon
                }
              }),
              !_vm.hiddenIcon
                ? _c("icon-svg", {
                    attrs: {
                      name: _vm.iconName,
                      color: _vm.colorIcon,
                      size: "40"
                    }
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "mx-5 text-black",
                  staticStyle: {
                    flex: "1 1 auto",
                    "min-width": "0",
                    "font-size": "0.875rem",
                    color: "#4b4b4bee"
                  }
                },
                [_vm._t("default")],
                2
              ),
              _c("v-spacer"),
              _c(
                "div",
                {
                  staticClass: "base-alert__actions d-flex align-items-center",
                  staticStyle: { gap: "8px", "flex-shrink": "0" }
                },
                [_vm._t("button")],
                2
              ),
              _vm.showClose
                ? _c(
                    "button",
                    {
                      attrs: { "data-testid": "base-alert-close" },
                      on: { click: _vm.removeAlert }
                    },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "mdi-close-circle",
                          color: "secondary",
                          size: "24"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }